// Constants for the individual workflow, where the workspace owner and the
// patient are the same person. The owner's own `patient_org_membership` is
// created by `org.ensureSelfPatient` and reused by every self-serve connect,
// so the two literals that identify it live here rather than at three call
// sites.

/** `patient_org_membership.external_id` of the owner's own membership. */
export const SELF_PATIENT_EXTERNAL_ID = "self";

/** `patient_org_membership.source` recorded when the owner is the patient. */
export const SELF_PATIENT_SOURCE = "individual";
